import { ROLES } from 'utils/user'
import { EditCustomerCall } from './EditCustomerCall'

export default {
  edit: EditCustomerCall,
  permissions: [ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER_SUPPORT],
}
